export const translations = {
  pt: {
    nav: {
      sociedade: "Sociedade",
      projetos: "Projetos",
      primewash: "PrimeWash",
      contactos: "Contactos",
      cta: "Vamos Falar",
    },
    home: {
      eyebrow: "Bola8 AzorHomes — Açores",
      heroTitle: "Mais do que construir casas: entregamos moradias pensadas para valorizar.",
      heroSubtitle:
        "Do projeto à entrega final, com controlo total de qualidade, prazo e investimento.",
      heroCta: "Vamos Falar",
      heroSecondaryCta: "Ver Projetos",
      heroScroll: "Descobrir",
      positioningEyebrow: "Posicionamento",
      positioning:
        "A Bola 8 AzorHomes nasce da união entre estratégia e execução. Unimos a análise de mercado e valorização imobiliária com a experiência técnica em construção moderna, criando projetos pensados não apenas para viver — mas para valorizar ao longo do tempo.",
      servicesEyebrow: "Serviços",
      servicesTitle: "Três áreas. Uma visão integrada.",
      service1Title: "Construção Chave na Mão",
      service1Desc:
        "Gestão integral do projeto, desde o conceito até à entrega final, com controlo rigoroso de todas as fases da obra.",
      service1Link: "Saber mais",
      service2Title: "Desenvolvimento de Projetos",
      service2Desc:
        "Análise de viabilidade, definição de conceito e acompanhamento estratégico para maximizar o potencial do imóvel.",
      service2Link: "Saber mais",
      service3Title: "AZOR PrimeWash",
      service3Desc:
        "Intervenções técnicas de limpeza e manutenção de fachadas e coberturas, orientadas para preservação e valorização do imóvel. Serviço disponível também para clientes externos.",
      service3Link: "Ver PrimeWash",
      projectsEyebrow: "Projetos",
      projectsTitle: "Arquitetura contemporânea nos Açores.",
      projectsCta: "Ver todos os projetos",
      diffEyebrow: "Diferenciação",
      diffTitle: "Não construímos apenas casas.",
      diffIntro:
        "Desenvolvemos projetos com critério, pensados para reduzir risco, controlar investimento e garantir valorização.",
      diff1Title: "Controlo de custos",
      diff1Desc:
        "Orçamentação detalhada, sem surpresas. Gerimos cada euro do seu investimento.",
      diff2Title: "Gestão integral",
      diff2Desc:
        "Um único responsável do projeto à entrega. Coordenação total de obra.",
      diff3Title: "Adaptado ao clima dos Açores",
      diff3Desc:
        "Materiais e soluções construtivas pensados para o clima insular — humidade, vento e longevidade.",
      diff4Title: "Valorização do investimento",
      diff4Desc:
        "Análise prévia de mercado e escolhas construtivas orientadas para o retorno.",
      ctaTitle: "Pronto para iniciar o seu projeto?",
      ctaSubtitle:
        "Responda a algumas perguntas rápidas — entraremos em contacto em 24h.",
    },
    sociedade: {
      eyebrow: "Quem Somos",
      title: "Visão de mercado e execução técnica — ao mesmo tempo.",
      lead:
        "A Bola 8 AzorHomes resulta da união de duas áreas complementares: visão de mercado imobiliário e execução técnica em construção. Por um lado, a análise, aquisição e valorização de ativos. Por outro, a capacidade de construir com rigor, inovação e controlo.",
      leadExtra:
        "Esta combinação permite-nos desenvolver projetos com coerência total — da decisão inicial ao resultado final.",
      originTitle: "Origem",
      originIntro:
        "A empresa nasce da colaboração entre dois perfis com experiência real no terreno.",
      founder1Name: "Cátia",
      founder1Role: "Análise e investimento imobiliário",
      founder1Bio:
        "Com percurso na análise de mercado imobiliário, destaca-se pela abordagem estratégica e pela capacidade de identificar oportunidades de valorização de ativos. Conta com experiência na gestão de investimento imobiliário, através da AzorUnique, bem como no segmento do alojamento local, o que lhe confere uma visão prática sobre comportamento de mercado, procura e rentabilidade.",
      founder2Name: "João",
      founder2Role: "Construção e execução técnica",
      founder2Bio:
        "Empresário da área da construção, com experiência em sistemas construtivos modernos, nomeadamente LSF, impermeabilizações e soluções técnicas de desempenho. Sócio-gerente da empresa de construção Janeiro e Tavares, detentora das marcas AZORTHERM e AZORSTEEL, com intervenção em soluções orientadas para eficiência, durabilidade e qualidade de execução.",
      originClose:
        "A complementaridade destas áreas permite uma abordagem integrada, orientada para eficiência e resultado.",
      conceptTitle: "O Conceito \u201CBola 8\u201D",
      conceptIntro: "O nome Bola 8 não é aleatório. Representa:",
      c1: "Equilíbrio entre decisão e execução",
      c2: "Visão estratégica e concretização",
      c3: "Um ciclo contínuo de oportunidades",
      conceptClose:
        "O número 8, associado ao conceito de infinito, reflete a forma como encaramos cada projeto: não como um fim, mas como parte de um processo contínuo de criação de valor.",
      distinguishTitle: "O Que Nos Distingue",
      d1: "Decisão com base em análise real de mercado",
      d2: "Execução com controlo técnico rigoroso",
      d3: "Integração total entre investimento e construção",
      d4: "Foco em valorização, não apenas construção",
      visionTitle: "Visão",
      visionText:
        "Desenvolver projetos com consistência, capazes de gerar valor no tempo — para clientes, investidores e território.",
    },
    projetos: {
      eyebrow: "Portfolio",
      title: "Projetos em desenvolvimento.",
      subtitle:
        "Uma seleção de moradias contemporâneas nos Açores, com foco em qualidade construtiva e valorização.",
      locationLabel: "Localização",
      statusLabel: "Estado",
      typologyLabel: "Tipologia",
      viewDetails: "Ver detalhes",
    },
    projectsData: [
      {
        slug: "moradia-sao-roque",
        name: "Moradia São Roque",
        location: "São Roque, Ponta Delgada",
        typology: "T7 · 502 m²",
        status: "Em construção",
        description:
          "Moradia de dois pisos com 502 m² de área bruta de construção. O projeto integra casa principal, 2 unidades independentes (T1 e T2) e um total de 7 quartos. A distribuição permite utilização como habitação própria ou com componente de rendimento.",
      },
      {
        slug: "laranjeiras-villas-lote-21",
        name: "Moradia Lote 21 · Laranjeiras Villas",
        location: "Parque Século XXI, São Pedro — Ponta Delgada",
        typology: "V4 · 297,45 m²",
        status: "Em construção",
        description:
          "Moradia contemporânea de dois pisos, integrada no Loteamento Laranjeiras Villas, numa localização privilegiada em Ponta Delgada. Um projeto pensado para quem procura o luxo de viver na cidade sem abdicar de espaço, privacidade, jardim, piscina e todas as comodidades do dia a dia. A zona social privilegia ambientes amplos e luminosos, com open space e ligação direta ao jardim e à piscina, criando uma vivência fluida entre interior e exterior. No primeiro piso, a área privada é composta por 3 suites de grandes dimensões: duas com 25 m² e uma master suite com 45 m², reforçando o caráter exclusivo e familiar da moradia. Construída em LSF, combina eficiência, conforto térmico, resistência e rigor construtivo, numa moradia pensada para oferecer qualidade de vida, funcionalidade e valorização a longo prazo.",
      },
      {
        slug: "vivenda-feteiras-1",
        name: "Vivenda Vista Mar Feteiras 1",
        location: "Feteiras, Ponta Delgada",
        typology: "T3 · 260 m²",
        status: "Em desenvolvimento",
        hidden: true,
        description:
          "Moradia térrea de tipologia T3, com 260 m² de área bruta de construção. Integra ginásio e piscina com vista mar, com uma organização funcional em rés do chão que privilegia conforto, fluidez dos espaços e relação com o exterior.",
      },
      {
        slug: "vivenda-feteiras-2",
        name: "Vivenda Vista Mar Feteiras 2",
        location: "Feteiras, Ponta Delgada",
        typology: "T3 · 270 m²",
        status: "Em desenvolvimento",
        hidden: true,
        description:
          "Moradia térrea de tipologia T3, com 270 m² de área bruta de construção. Arquitetura moderna, com abordagem focada na privacidade da fachada e abertura controlada para o exterior, criando um ambiente resguardado e orientado para o mar. Organização funcional em rés do chão, pensada para conforto, fluidez dos espaços e ligação ao exterior.",
      },
    ],
    primewash: {
      eyebrow: "Sub-brand",
      title: "AZOR PrimeWash",
      headline: "Limpeza técnica de fachadas e telhados.",
      subheadline:
        "A AZOR PrimeWash é o serviço especializado da Bola8 AzorHomes para limpeza e manutenção de superfícies exteriores, com foco na preservação e valorização do imóvel.",
      cta: "Solicitar avaliação",
      removeTitle: "Atuamos na remoção de",
      r1: "Verdetes e fungos",
      r2: "Sujidade acumulada",
      r3: "Manchas em fachadas e coberturas",
      methodText:
        "Utilizamos métodos de limpeza controlada, adequados a cada superfície, garantindo eficácia sem comprometer a integridade dos materiais.",
      servicesTitle: "Aplicações",
      s1Title: "Fachadas pintadas",
      s1Desc: "Limpeza técnica de fachadas pintadas com remoção segura de verdetes, fungos e sujidade acumulada.",
      s2Title: "Capoto (ETICS)",
      s2Desc: "Manutenção especializada de sistemas ETICS, preservando o isolamento e a estética original.",
      s3Title: "Telhados metálicos e telha",
      s3Desc: "Intervenção técnica em coberturas metálicas e de telha, com métodos adequados a cada tipo de superfície.",
      s4Title: "Muros e pavimentos exteriores",
      s4Desc: "Lavagem de muros e pavimentos exteriores em betão, calçada e microcimento.",
      whyTitle: "Abordagem",
      whyIntro:
        "Cada intervenção é analisada de forma individual, considerando o tipo de superfície, grau de exposição e condições ambientais, assegurando uma atuação ajustada e duradoura.",
      positioningTitle: "Posicionamento",
      positioningText:
        "Intervenções orientadas para manutenção preventiva e valorização do imóvel, integradas numa lógica de preservação a longo prazo.",
    },
    contactos: {
      eyebrow: "Contactos",
      title: "Interessado em algum projeto? Vamos falar.",
      subtitle:
        "Responderemos em menos de 24h úteis. Pode também escrever-nos diretamente por WhatsApp.",
      name: "Nome",
      email: "Email",
      phone: "Telefone",
      subject: "Assunto",
      message: "Mensagem",
      submit: "Enviar mensagem",
      submitting: "A enviar...",
      success: "Mensagem enviada. Entraremos em contacto em breve.",
      error: "Ocorreu um erro. Tente novamente ou contacte-nos por WhatsApp.",
      placeholderName: "Nome completo",
      placeholderEmail: "o.seu@email.com",
      placeholderPhone: "+351 9XX XXX XXX",
      placeholderSubject: "Construção chave na mão, PrimeWash, ...",
      placeholderMessage: "Conte-nos sobre o seu projeto...",
      addressLabel: "Morada",
      emailLabel: "Email",
      phoneLabel: "Telefone",
      whatsappCta: "Falar no WhatsApp",
      required: "Campo obrigatório",
      invalidEmail: "Email inválido",
    },
    footer: {
      tagline: "Construção e desenvolvimento de moradias nos Açores.",
      company: "Empresa",
      services: "Serviços",
      contact: "Contacto",
      rights: "Todos os direitos reservados.",
    },
  },

  en: {
    nav: {
      sociedade: "Company",
      projetos: "Projects",
      primewash: "PrimeWash",
      contactos: "Contact",
      cta: "Let's Talk",
    },
    home: {
      eyebrow: "Bola8 AzorHomes — Azores",
      heroTitle: "More than building houses: we deliver homes designed to appreciate.",
      heroSubtitle:
        "From design to handover — total control of quality, timeline and investment.",
      heroCta: "Let's Talk",
      heroSecondaryCta: "View Projects",
      heroScroll: "Discover",
      positioningEyebrow: "Positioning",
      positioning:
        "Bola 8 AzorHomes was born from the union between strategy and execution. We combine real estate market analysis and value appreciation with technical expertise in modern construction, creating projects designed not only to live in — but to appreciate over time.",
      servicesEyebrow: "Services",
      servicesTitle: "Three areas. One integrated vision.",
      service1Title: "Turnkey Construction",
      service1Desc:
        "End-to-end project management, from concept to final handover, with rigorous control of every construction phase.",
      service1Link: "Learn more",
      service2Title: "Project Development",
      service2Desc:
        "Feasibility analysis, concept definition and strategic support to maximise each property's potential.",
      service2Link: "Learn more",
      service3Title: "AZOR PrimeWash",
      service3Desc:
        "Technical cleaning and maintenance of facades and roofs, focused on preserving and increasing property value. Service also available for external clients.",
      service3Link: "Visit PrimeWash",
      projectsEyebrow: "Projects",
      projectsTitle: "Contemporary architecture in the Azores.",
      projectsCta: "View all projects",
      diffEyebrow: "Why Bola8",
      diffTitle: "We don't just build houses.",
      diffIntro:
        "We develop projects with criteria, designed to reduce risk, control investment and ensure value appreciation.",
      diff1Title: "Cost control",
      diff1Desc:
        "Detailed budgeting with no surprises. We manage every euro of your investment.",
      diff2Title: "Integrated management",
      diff2Desc:
        "A single responsible lead from project to handover. Full site coordination.",
      diff3Title: "Built for the Azores",
      diff3Desc:
        "Materials and building solutions designed for the island climate — humidity, wind and longevity.",
      diff4Title: "Investment appreciation",
      diff4Desc:
        "Prior market analysis and construction choices focused on ROI.",
      ctaTitle: "Ready to start your project?",
      ctaSubtitle: "Answer a few quick questions — we'll get back to you in 24h.",
    },
    sociedade: {
      eyebrow: "Company",
      title: "Real estate developer and builder. At the same time.",
      lead:
        "Bola8 AzorHomes was born to raise the construction standard in the Azores, merging real estate investment analysis with controlled technical execution.",
      mission:
        "Every home we build should also be a sound investment for those who live in it — or those who develop it.",
      valuesTitle: "Values",
      v1: "Full transparency on costs and timing.",
      v2: "Build quality, from concrete to detail.",
      v3: "Closeness: each project has a single point of contact.",
      v4: "Environmental responsibility and landscape integration.",
      approachTitle: "How we work",
      step1Title: "01 — Analysis",
      step1: "We study the land, the market and appreciation potential before designing.",
      step2Title: "02 — Design",
      step2:
        "Architecture and engineering design, fully coordinated with execution — no rework.",
      step3Title: "03 — Construction",
      step3:
        "In-house teams and selected partners. Quality control at every stage.",
      step4Title: "04 — Handover",
      step4:
        "Keys, documentation and warranty delivered. We support you post-handover as well.",
    },
    projetos: {
      eyebrow: "Portfolio",
      title: "Projects in development.",
      subtitle:
        "A selection of contemporary homes in the Azores, focused on build quality and appreciation.",
      locationLabel: "Location",
      statusLabel: "Status",
      typologyLabel: "Typology",
      viewDetails: "View details",
    },
    projectsData: [
      {
        slug: "moradia-sao-roque",
        name: "São Roque House",
        location: "São Roque, Ponta Delgada",
        typology: "7BR · 502 m²",
        status: "Under construction",
        description:
          "Two-storey home with 502 m² of gross building area. The project includes the main house, 2 independent units (1BR and 2BR) and a total of 7 bedrooms. The layout allows it to be used as a private residence or with a rental component.",
      },
      {
        slug: "laranjeiras-villas-lote-21",
        name: "Lot 21 House · Laranjeiras Villas",
        location: "Parque Século XXI, São Pedro — Ponta Delgada",
        typology: "4BR · 297.45 m²",
        status: "Under construction",
        description:
          "Contemporary two-storey home, part of the Laranjeiras Villas development, in a privileged location in Ponta Delgada. A project designed for those seeking the luxury of city living without giving up space, privacy, garden, pool and everyday comfort. The social area features open, luminous spaces with direct connection to the garden and pool, creating a fluid indoor-outdoor experience. On the upper floor, the private area includes 3 large en-suite bedrooms: two of 25 m² and a master suite of 45 m², reinforcing the exclusive and family character of the home. Built in LSF, it combines efficiency, thermal comfort, resistance and construction rigour — a home designed to deliver quality of life, functionality and long-term appreciation.",
      },
      {
        slug: "vivenda-feteiras-1",
        name: "Sea View Feteiras 1",
        location: "Feteiras, Ponta Delgada",
        typology: "3BR · 260 m²",
        status: "In development",
        hidden: true,
        description:
          "Single-storey 3-bedroom home with 260 m² of gross building area. Features a gym and a pool with sea view, with a ground-floor layout that prioritises comfort, spatial flow and connection to the outdoors.",
      },
      {
        slug: "vivenda-feteiras-2",
        name: "Sea View Feteiras 2",
        location: "Feteiras, Ponta Delgada",
        typology: "3BR · 270 m²",
        status: "In development",
        hidden: true,
        description:
          "Single-storey 3-bedroom home with 270 m² of gross building area. Modern architecture focused on facade privacy and controlled openings to the exterior, creating a sheltered environment oriented towards the sea. Functional ground-floor layout designed for comfort, spatial flow and indoor-outdoor connection.",
      },
    ],
    primewash: {
      eyebrow: "Sub-brand",
      title: "AZOR PrimeWash",
      headline: "Technical cleaning for facades and roofs.",
      subheadline:
        "AZOR PrimeWash is Bola8 AzorHomes' specialised service for the cleaning and maintenance of exterior surfaces, focused on preserving and increasing property value.",
      cta: "Request an assessment",
      removeTitle: "We remove",
      r1: "Moss and fungi",
      r2: "Accumulated dirt",
      r3: "Stains on facades and roofs",
      methodText:
        "We use controlled cleaning methods, tailored to each surface, ensuring effectiveness without compromising material integrity.",
      servicesTitle: "Applications",
      s1Title: "Painted facades",
      s1Desc: "Technical cleaning of painted facades with safe removal of moss, fungi and accumulated dirt.",
      s2Title: "ETICS (thermal coating)",
      s2Desc: "Specialised maintenance of ETICS systems, preserving insulation and original aesthetics.",
      s3Title: "Metal and tile roofs",
      s3Desc: "Technical intervention on metal and tile roofs, with methods tailored to each surface type.",
      s4Title: "Walls & outdoor pavements",
      s4Desc: "Washing of walls and outdoor pavements in concrete, cobblestone and micro-cement.",
      whyTitle: "Approach",
      whyIntro:
        "Each intervention is analysed individually, considering surface type, exposure and environmental conditions, ensuring an adjusted and long-lasting result.",
      positioningTitle: "Positioning",
      positioningText:
        "Interventions focused on preventive maintenance and property value appreciation, integrated into a long-term preservation logic.",
    },
    contactos: {
      eyebrow: "Contact",
      title: "Interested in a project? Let's talk.",
      subtitle:
        "We reply within 24 business hours. You can also reach us directly on WhatsApp.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      submit: "Send message",
      submitting: "Sending...",
      success: "Message sent. We'll be in touch shortly.",
      error: "Something went wrong. Please try again or contact us on WhatsApp.",
      placeholderName: "Full name",
      placeholderEmail: "your@email.com",
      placeholderPhone: "+351 9XX XXX XXX",
      placeholderSubject: "Turnkey construction, PrimeWash, ...",
      placeholderMessage: "Tell us about your project...",
      addressLabel: "Address",
      emailLabel: "Email",
      phoneLabel: "Phone",
      whatsappCta: "Chat on WhatsApp",
      required: "Required field",
      invalidEmail: "Invalid email",
    },
    footer: {
      tagline: "Home construction and development in the Azores.",
      company: "Company",
      services: "Services",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },
};

export const CONTACT = {
  address: "Parque Industrial da Ribeira Grande, Rua da Mecânica n.º 4 C, 9600-499 Ribeira Grande",
  email: "bola8azorhomes@outlook.pt",
  phone: "+351 916 927 419",
  phoneRaw: "+351916927419",
  whatsapp: "351916927419",
  website: "bola8azorhomes.pt",
};

export const LOGO_URL = "/logo_bola8.png";

// Real project images (uploaded by client)
export const PROJECT_IMAGES = {
  "moradia-sao-roque": [
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/c56h7hd8_2.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/mcxgn5f0_1.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/l34wf47q_3.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/79qvba17_4.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/ifwrltcc_5.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/wkrta5ls_7.jpeg",
  ],
  "laranjeiras-villas-lote-21": [
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/i9tdl8me_1.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/pz9lgvgk_2.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/c1xuhud5_3.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/rze85s8x_4.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/wkbyxbsx_5.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/4djksen0_6.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/7ygnhnr6_7.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/z3idjwjl_8.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/ptk6umbs_9.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/mjadg422_10.jpeg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_bola8-construcao/artifacts/q4atujbv_11.jpeg",
  ],
  "vivenda-feteiras-1": [
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/zj66yjfu_2.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/d66teqh9_3.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/tqpej241_4.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/t0qt2ryr_5.png",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/iuotukmr_6.png",
  ],
  "vivenda-feteiras-2": [
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/s30lht0c_1.png",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/4lurx7uw_2.png",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/shr456va_3.jpeg",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/z05wsro9_4.png",
    "https://customer-assets.emergentagent.com/job_bola8-construcao/artifacts/zbkb0ure_5.png",
  ],
};
export const PRIMEWASH_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_e2bc7dce-a438-4e3d-b466-07c3d01ec8ed/artifacts/kmd9ykzv_Logo%20sem%20fundo.png";
